import { isValidTelegramOutboundUrl, normalizePublicOutboundUrl } from "@/lib/telegramPublicInviteUrl";

/** Body seguro para POST /api/free-join (omite URLs no-Telegram, ej. MP por error de config). */
export function buildFreeJoinRequestBody(
  freeTelegramUrl?: string | null,
): { free_telegram_url?: string } {
  const raw = String(freeTelegramUrl ?? "").trim();
  if (!raw || !isValidTelegramOutboundUrl(raw)) return {};
  return { free_telegram_url: normalizePublicOutboundUrl(raw) };
}

/** Registra free tier en DB (best-effort). Telegram URL opcional. */
export async function postFreeJoinBestEffort(
  getToken: () => Promise<string | null>,
  freeTelegramUrl?: string | null,
): Promise<void> {
  try {
    const token = await getToken();
    if (!token) return;
    await fetch("/api/free-join", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify(buildFreeJoinRequestBody(freeTelegramUrl)),
      keepalive: true,
    });
  } catch {
    // Best-effort: admin puede crear el registro manualmente.
  }
}
